import { AuditWrapper } from '../../../components/hub/AuditWrapper';
import { EmailDeliverabilityPage } from '../../EmailDeliverabilityPage';

export function HubEmailPage() {
  return (
    <AuditWrapper>
      <EmailDeliverabilityPage />
    </AuditWrapper>
  );
}
